import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { JobOfferComponent } from './job-offer/job-offer.component';
import { BrandsComponent } from './brands/brands.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ExclusiveSolutionsComponent } from './solutions/exclusive-solutions/exclusive-solutions.component';
import { FinancialSolutionsComponent } from './solutions/financial-solutions/financial-solutions.component';
import { CertifactesComponent } from './certifactes/certifactes.component';
import { RoadMapComponent } from './road-map/road-map.component';
import { BugBountyComponent } from './bug-bounty/bug-bounty.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    data: {
      title: 'ایپام | شرکت ایده پرداز دانش نوین آرشام',
      keywords: '!نگران چالش‌های خود نباشید، ایپــــام را ارائه دهید',
      description: '. شرکت دانش‌بنیان ایده پرداز دانش نوین آرشام (ایپام)، به ارائه خدمات و راه‌کارهای کم‌نظیر در حوزه فین‌تک می‌پردازد'
    }
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    data: {
      title: 'ایپام | درباره ما',
      keywords: 'درباره ایپام',
      description:
        'شرکت دانش‌بنیان ایده‌ پرداز دانش نوین آرشام (ایپام) در سال 1396 تاسیس و با اخذ مجوزهای پرداخت‌یاری و پرداخت‌سازی از بانک مرکزی جمهوری اسلامی و شاپرک، به ارائه خدمات و راه‌کارهای بی‌همتا در حوزه‌های مالی همچون بانکداری مجازی، بانکداری باز، اینشورتک و سوپرمارکت مالی می‌پردازد'
    }
  },
  {
    path: 'solutions/exclusive',
    component: ExclusiveSolutionsComponent,
    data: {
      title: 'ایپام | راه‌کارهای اختصاصی',
      keywords: 'درباره ایپام',
      description:
        'هر چالش حداقل یک راه‌حل بی‌همتا و ایده‌های بزرگ نیاز به بینش و تحلیل دقیق دارند. ایپام با تحلیل و بررسی نیازمندی‌های شما با توجه به سطح دانش و زیرساخت‌های منحصربه‌فرد خود، بهترین راه‌کارهای یکتا را برای شما و توسعه کسب‌وکار شما پیشنهاد می‌کند'
    }
  },
  {
    path: 'certificate',
    component: CertifactesComponent,
    data: {
      title: 'ایپام | راه‌کارهای اختصاصی',
      keywords: 'درباره ایپام',
      description:
        'هر چالش حداقل یک راه‌حل بی‌همتا و ایده‌های بزرگ نیاز به بینش و تحلیل دقیق دارند. ایپام با تحلیل و بررسی نیازمندی‌های شما با توجه به سطح دانش و زیرساخت‌های منحصربه‌فرد خود، بهترین راه‌کارهای یکتا را برای شما و توسعه کسب‌وکار شما پیشنهاد می‌کند'
    }
  },
  {
    path: 'solutions/financial',
    component: FinancialSolutionsComponent,
    data: {
      title: 'ایپام | راه‌کارهای مالی ',
      keywords: 'درباره ایپام',
      description:
        'ارائه راه‌کارهای مبتنی بر کیف پول ، ارائه راه‌کارهای مورد نیاز برای اخذ مجوز پرداخت‌یاری ،ارائه راه‌کارهای مورد نیاز برای اخذ مجوز پرداخت‌یاری ، ارائه راه‌کارهای مبتنی بر WealthTech ، ارائه راه‌کارهای مبتنی بر تحلیل داده – BI ، ارائه راه‌کارهای بانکی'
    }
  },
  {
    path: 'brands/:name',
    component: BrandsComponent,
    data: {
      title: 'ایپام | برندها ',
      keywords: 'برندهای ایپام',
      description: 'برندهای ایپام'
    }
  },
  {
    path: 'job-offer',
    component: JobOfferComponent,
    data: {
      title: 'ایپام | فرصت های شغلی ',
      keywords: 'فرصت های شغلی ایپام',
      description:
        '. شرکت دانش‌بنیان ایده پرداز دانش نوین آرشام (ایپام)، به ارائه خدمات و راه‌کارهای کم‌نظیر در حوزه فین‌تک می‌پردازدایپام همواره به دنبال کشف استعداد و جذب نیروی خلاق و نوآور است. ما در ایپام با استقبال از چالش‌ها به دنبال نوآوری و پیشرفت در جهت رفع آن با استفاده از ظرفیت فناوری‌های روزآمد هستیم'
    }
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      title: 'ایپام | تماس با ما ',
      keywords: 'تماس با ایپام',
      description: '. شرکت دانش‌بنیان ایده پرداز دانش نوین آرشام (ایپام)، به ارائه خدمات و راه‌کارهای کم‌نظیر در حوزه فین‌تک می‌پردازد'
    }
  },
  {
    path: 'road-map',
    component: RoadMapComponent,
    data: {
      title: 'ایپام | نقشه راه',
      keywords: 'نقشه راه',
      description: '. شرکت دانش‌بنیان ایده پرداز دانش نوین آرشام (ایپام)، به ارائه خدمات و راه‌کارهای کم‌نظیر در حوزه فین‌تک می‌پردازد'
    }
  },
  {
    path: 'bug-bounty',
    component: BugBountyComponent,
    data: {
      title: 'ایپام | باگ‌ بانتی ',
      keywords: 'باگ بانتی ایپام',
      description:
        'سامانه های تحت پوشش تیم فنی ایپام با هدف شناسایی و رفع آسیب‌پذیری‌های احتمالی خود و ارائه هر چه بهتر خدمات در بستری امن، برنامه «باگ بانتی» رااجرا می‌کند.'
    }
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule {}
